module.exports = {
      id: "arrow-down-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#arrow-down-icon",
      toString: function () {
        return this.url;
      }
    }